module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/project-master/project-master.component.html
// module id = ./src/app/master/project-master/project-master.component.html
// module chunks = main